export default __webpack_public_path__ + "static/tooltip-contents-dont-light-60ff46d84ab7f015e1c723e30fb3921a.png";